/* Theme switching is presentation only; it does not validate checkout inventory or dates. */
(function () {
  'use strict';
  function resolveMode(now, switchAt, forced, query, stored) {
    if (forced === 'christmas' || forced === 'newyear') return forced;
    if (Number.isFinite(switchAt) && now >= switchAt) return 'newyear';
    if (query === 'revelion') return 'newyear';
    if (query === 'craciun') return 'christmas';
    return stored === 'newyear' ? 'newyear' : 'christmas';
  }
  function countdown(now, closing) {
    if (!Number.isFinite(closing)) return null;
    var seconds = Math.max(0, Math.ceil((closing - now) / 1000));
    return {closed: now >= closing, days: Math.floor(seconds / 86400), hours: Math.floor(seconds % 86400 / 3600), minutes: Math.floor(seconds % 3600 / 60), seconds: seconds % 60};
  }
  if (typeof module !== 'undefined' && module.exports) module.exports = {resolveMode: resolveMode, countdown: countdown};
  if (typeof document === 'undefined') return;
  var timer;
  var phoneMedia = matchMedia('(max-width: 760px)');
  function setupFooter(reset) {
    document.querySelectorAll('[data-ce-footer-group]').forEach(function (group) {
      if (reset || !group.dataset.ceReady) {
        group.open = !phoneMedia.matches;
        group.querySelector('summary').tabIndex = phoneMedia.matches ? 0 : -1;
        group.dataset.ceReady = 'true';
      }
    });
  }
  phoneMedia.addEventListener('change', function () {
    setupFooter(true);
    document.querySelectorAll('.ce-mobile-menu').forEach(function (menu) { menu.open = false; });
  });
  document.addEventListener('click', function (event) {
    var summary = event.target.closest('[data-ce-footer-group] > summary');
    if (summary && !phoneMedia.matches) event.preventDefault();
    document.querySelectorAll('.ce-mobile-menu[open]').forEach(function (menu) {
      if (!menu.contains(event.target) || event.target.closest('a')) menu.open = false;
    });
  });
  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape') document.querySelectorAll('.ce-mobile-menu[open]').forEach(function (menu) {
      menu.open = false; menu.querySelector('summary').focus();
    });
  });
  function renderCountdown(element, remaining, occasion) {
    var units = element.querySelector('.ce-countdown-units');
    var status = element.querySelector('.ce-countdown-status');
    var message = !remaining ? 'Data de închidere urmează să fie confirmată' : remaining.closed ? 'Precomenzile de ' + occasion + ' sunt închise' : '';
    if (!units || !status) return;
    units.hidden = !!message;
    status.hidden = !message;
    if (message) {
      status.textContent = message;
      element.setAttribute('aria-label', message);
    } else {
      element.querySelectorAll('[data-ce-time]').forEach(function (unit) {
        unit.textContent = String(remaining[unit.dataset.ceTime]).padStart(2, '0');
      });
      element.setAttribute('aria-label', remaining.days + ' zile, ' + remaining.hours + ' ore, ' + remaining.minutes + ' minute și ' + remaining.seconds + ' secunde până la închiderea precomenzilor de ' + occasion);
    }
  }
  function init() {
    clearInterval(timer);
    setupFooter(false);
    var config = document.querySelector('[data-ce-config]');
    if (!config) return;
    var closing = Date.parse(config.dataset.close), switchAt = Date.parse(config.dataset.switch), nyeClosing = Date.parse(config.dataset.nyeClose);
    var collectionPage = document.querySelector('[data-ce-collection]');
    if (collectionPage) { closing = Date.parse(collectionPage.dataset.christmasClose); nyeClosing = Date.parse(collectionPage.dataset.newyearClose); }
    var productPage = document.querySelector('[data-ce-product], [data-ce-collection][data-occasion=christmas], [data-ce-collection][data-occasion=newyear]');
    if (productPage) {
      if (productPage.dataset.occasion === 'newyear') nyeClosing = Date.parse(productPage.dataset.closeAt);
      else closing = Date.parse(productPage.dataset.closeAt);
    }
    var forced = config.dataset.mode, stored;
    var key = 'ce-holiday-mode-2026';
    try { stored = sessionStorage.getItem(key); } catch (_) {}
    var query = productPage ? (productPage.dataset.occasion === 'newyear' ? 'revelion' : 'craciun') : new URLSearchParams(location.search).get('masa');
    var mode = resolveMode(Date.now(), switchAt, forced, query, stored);
    function setMode(next) {
      mode = resolveMode(Date.now(), switchAt, forced, next === 'newyear' ? 'revelion' : 'craciun', next);
      document.documentElement.dataset.ceTheme = mode;
      document.querySelectorAll('.ce-actions [data-ce-mode]').forEach(function (a) { a.classList.toggle('ce-button-outline', a.dataset.ceMode !== mode); });
      document.querySelectorAll('[data-ce-christmas]').forEach(function (e) { e.hidden = (productPage && e.closest('.ce-announcement') ? productPage.dataset.occasion : mode) !== 'christmas'; });
      document.querySelectorAll('[data-ce-newyear]').forEach(function (e) { e.hidden = (productPage && e.closest('.ce-announcement') ? productPage.dataset.occasion : mode) !== 'newyear'; });
      document.querySelectorAll('.ce-nav [data-ce-mode], .ce-mobile-menu-panel [data-ce-mode]').forEach(function (a) { if (a.dataset.ceMode === mode) a.setAttribute('aria-current', 'page'); else a.removeAttribute('aria-current'); });
      try { sessionStorage.setItem(key, mode); } catch (_) {}
      // Keep the chosen occasion throughout CE collections and product links.
      document.querySelectorAll('.ce-site a[href]').forEach(function (link) {
        var url;
        try { url = new URL(link.href, location.href); } catch (_) { return; }
        if (url.origin !== location.origin || !/\/(collections|products)\//.test(url.pathname)) return;
        var linkMode = link.dataset.ceMode || (productPage ? productPage.dataset.occasion : mode);
        var view = linkMode === 'newyear' ? 'revelion' : 'craciun';
        if (!url.searchParams.has('view') || link.dataset.ceAutoView === 'true') {
          url.searchParams.set('view', view);
          link.dataset.ceAutoView = 'true';
          link.href = url.pathname + url.search + url.hash;
        }
      });
      document.dispatchEvent(new CustomEvent('ce:theme-change', {detail: {mode: mode}}));
    }
    function tick() {
      var now = Date.now(), remaining = countdown(now, closing);
      if (forced === 'auto' && Number.isFinite(switchAt) && now >= switchAt && mode !== 'newyear') setMode('newyear');
      document.querySelectorAll('[data-ce-countdown]').forEach(function (e) { renderCountdown(e, remaining, 'Crăciun'); });
      var nyeRemaining = countdown(now, nyeClosing);
      document.querySelectorAll('[data-ce-nye-countdown]').forEach(function (e) { renderCountdown(e, nyeRemaining, 'Revelion'); });
      document.querySelectorAll('[data-ce-nye-deadline]').forEach(function (e) { e.textContent = nyeRemaining && nyeRemaining.closed ? 'Precomenzile de Revelion sunt închise' : 'Precomenzi până pe 28 decembrie'; });
      document.querySelectorAll('[data-ce-deadline]').forEach(function (e) { e.textContent = remaining && remaining.closed ? 'Precomenzile de Crăciun sunt închise' : 'Precomenzi până pe 21 decembrie'; });
      document.querySelectorAll('[data-ce-menu="christmas"] .ce-closed-note').forEach(function (e) { e.hidden = !(remaining && remaining.closed); });
    }
    setMode(mode); tick(); timer = setInterval(tick, 1000);
  }
  document.addEventListener('click', function (event) {
    var target = event.target.closest('[data-ce-mode]');
    if (!target) return;
    var next = target.dataset.ceMode;
    try { sessionStorage.setItem('ce-holiday-mode-2026', next); } catch (_) {}
    var url = new URL(target.href, location.href);
    if (url.pathname === location.pathname && url.origin === location.origin && url.hash) {
      event.preventDefault();
      history.replaceState(null, '', url.pathname + url.search + url.hash);
      init();
      var anchor = document.getElementById(url.hash.slice(1));
      if (anchor) anchor.scrollIntoView({behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'});
    }
  });
  document.addEventListener('shopify:section:load', init);
  document.addEventListener('shopify:section:unload', init);
  init();
})();
